import { Container, Label, version as pcuiVersion, revision as pcuiRevision } from '@playcanvas/pcui';
import { version as engineVersion, revision as engineRevision } from 'playcanvas';


class ThanksPopup extends Container {
    constructor(args = {}) {
        args = {
            ...args,
            id: 'about-popup',
            hidden: true,
            tabIndex: -1
        };

        super(args);

        // Handle keyboard events
        this.dom.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                this.hidden = true;
            }
            e.stopPropagation();
        });

        // Close when clicking outside dialog
        this.on('click', () => {
            this.hidden = true;
        });

        const dialog = new Container({
            id: 'about-dialog'
        });

        // Prevent clicks inside dialog from closing
        dialog.on('click', (event: MouseEvent) => {
            event.stopPropagation();
        });

        // Header bar
        const header = new Label({
            id: 'about-header',
            text: 'Thanks'
        });

        // Content area
        const content = new Container({
            id: 'about-content'
        });

        const projectNamePrefix = new Label({
            id: 'about-app-text',
            text: 'This Website is based on '
        });

        const projectName = new Label({
            id: 'about-app-link',
            text: 'Supersplat Editor'
        });
        const projectNameSuffix = new Label({
            id: 'about-app-text',
            text: ' modified from,'
        });

        const copyrightPrefix = new Label({
            id: 'about-app-text',
            text: ' Copyright(c)  '
        });

        const authorLabel = new Label({
            id: 'about-app-link',
            text: '@Donovan Hutchence'
        });
        const copyrightSuffix = new Label({
            id: 'about-app-text',
            text: 'All Rights Reserved.'
        });
        authorLabel.dom.addEventListener('click', () => {
            window.open('https://github.com/slimbuck', '_blank')?.focus();
        })

        const srcCodePrefix = new Label({
            id: 'about-app-text',
            text: 'Source Code Address: '
        });
        const githubLink = new Label({
            id: 'about-app-link',
            text: 'https://github.com/playcanvas/supersplat'
        });
        githubLink.dom.addEventListener('click', () => {
            window.open('https://github.com/playcanvas/supersplat', '_blank')?.focus();
        });

           // App name and version
        const project = new Container({
            id: 'about-wrap-content'
        });
        project.append(projectNamePrefix);
        project.append(projectName);
        project.append(projectNameSuffix);
        const copyright = new Container({
            id: 'about-wrap-content'
        })
        copyright.append(copyrightPrefix);
        copyright.append(authorLabel);
        copyright.append(copyrightSuffix);

        const link = new Container({
            id: 'about-wrap-content'
        })
        link.append(srcCodePrefix);
        link.append(githubLink);

        content.append(project);
        content.append(copyright);
        content.append(link);

        // Assemble dialog
        dialog.append(header);
        dialog.append(content);

        this.append(dialog);

        // Focus when shown so keyboard events work
        this.on('show', () => {
            this.dom.focus();
        });
    }
}

export { ThanksPopup };
